import classes from './StarWarsCrawl.module.css';

// [name, role] — the crawl's "Code Alliance".
const TEAM: [string, string][] = [
    ['AXEL', 'Lord of the Frontend'],
    ['DAVID', 'Keeper of the Ancient Code'],
    ['JEAN-EMMANUEL', 'Spring Padawan'],
    ['LUCAS', 'AI Whisperer'],
    ['MAXIME', 'Java Knight'],
    ['MAXIMILIEN', 'Guardian of Production'],
    ['PAULINE', 'Master of the PHP Force'],
];

// Hidden credits, Star Wars opening-crawl style. One of the two things the "credits" code shows at random.
export function StarWarsCrawl() {
    return (
        <div className={classes.viewport}>
            <div className={classes.fade} />
            <div className={classes.crawl}>
                <div className={classes.title}>
                    <p>BACKOFFICE</p>
                    <p>Episode MMXXVI</p>
                    <h1>A New Hope</h1>
                </div>

                <p>It is a period of great change. The OLD BACKOFFICE, after years of loyal
                    service, has grown powerful, mysterious, and increasingly difficult to
                    understand.</p>

                <p>From hidden repositories and forgotten APIs, a new generation of code has
                    emerged.</p>

                <p>Against impossible deadlines, legacy dependencies and bugs that cannot be
                    reproduced, a small band of developers continues the migration...</p>

                <h2>The Code Alliance</h2>

                <div className={classes.team}>
                    {TEAM.map(([name, role]) => (
                        <p key={name}><strong>{name}</strong><br />{role}</p>
                    ))}
                </div>

                <p>Together they fight an endless battle against technical debt, production
                    bugs, merge conflicts, and requirements that changed yesterday.</p>

                <p>Their mission continues...</p>

                <p>May the Force be with you, brave user of the Backoffice.</p>
            </div>
        </div>
    );
}
